import styled from 'styled-components';
import Button from 'core/ui/Button';
import { getColor, typeScale } from 'core/utils';
import { size } from 'styled-manila';

export const AuthBox = styled.a`
	display: flex;
	align-items: center;
	margin-bottom: ${typeScale(1)};
`;

export const Frame = styled.div`
	${size(60)};
	min-width: 60px;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 0 2px 4px 0 rgba(74, 74, 74, 0.3);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Author = styled.h6`
	margin: 0;
	font-size: ${typeScale(2)};
	line-height: 18px;
	letter-spacing: 0.24px;
	font-weight: 600;
	color: ${getColor("gray")};
`;

export const InfoCol = styled.div`
	margin-left: ${typeScale(1.5)};
`;

export const Stats = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	color: ${getColor('dustyGray')};
	font-size: 13px;

	svg {
		fill: currentColor;
		${size('1.1em')};
	}
`;

export const Stat = styled.div`
	display: flex;
	align-items: center;
	margin-right: ${typeScale(2)};
	padding: ${typeScale(0.5)} 0;
`;

export const Label = styled.span`
	margin: 0;
	margin-top: 4px;
	margin-left: ${typeScale(1)};
	line-height: 1;
	font-size: 14px;
`;

export const Subscribed = styled.span`
	display: block;
	padding-top: 4px;
	margin: 0;
	color: ${getColor('dustyGray')};
`;
